import { atom } from 'jotai'
import { EFetchReloadKey } from '../types'
import * as helpers from '../helpers'

type IFetchCommonToReloadValue = {
	count: number
	updatedAt: number | null
}

type IFetchCommonToReloadState = Record<EFetchReloadKey, IFetchCommonToReloadValue>

const DEFAULT_RECORD_STATE: IFetchCommonToReloadValue = {
	count: 0,
	updatedAt: null
}

const defaultState: IFetchCommonToReloadState = {
	[EFetchReloadKey.listAccountBuyer]: DEFAULT_RECORD_STATE,
	[EFetchReloadKey.listAccountTeam]: DEFAULT_RECORD_STATE,
	[EFetchReloadKey.listRevenueAgency]: DEFAULT_RECORD_STATE,
	[EFetchReloadKey.allParallelList]: DEFAULT_RECORD_STATE,
	[EFetchReloadKey.allList]: DEFAULT_RECORD_STATE
}

// base atom with initial value
export const fetchIsCommonToReloadAtom = atom<IFetchCommonToReloadState>(defaultState)

// smth like 'action-creators' from redux
// used for launchUpdate* of common dictionary lists data
export const launchUpdateListAccountBuyer = (prev: IFetchCommonToReloadState) => ({
	...prev,
	[EFetchReloadKey.listAccountBuyer]: {
		count: prev[EFetchReloadKey.listAccountBuyer].count + 1,
		updatedAt: helpers.getNowInMs()
	}
})
export const launchUpdateListAccountTeam = (prev: IFetchCommonToReloadState) => ({
	...prev,
	[EFetchReloadKey.listAccountTeam]: {
		count: prev[EFetchReloadKey.listAccountTeam].count + 1,
		updatedAt: helpers.getNowInMs()
	}
})
export const launchUpdateListRevenueAgency = (prev: IFetchCommonToReloadState) => ({
	...prev,
	[EFetchReloadKey.listRevenueAgency]: {
		count: prev[EFetchReloadKey.listRevenueAgency].count + 1,
		updatedAt: helpers.getNowInMs()
	}
})
export const launchUpdateAllParallelList = (prev: IFetchCommonToReloadState) => ({
	...prev,
	[EFetchReloadKey.allParallelList]: {
		count: prev[EFetchReloadKey.allParallelList].count + 1,
		updatedAt: helpers.getNowInMs()
	}
})
export const launchUpdateAllList = (prev: IFetchCommonToReloadState) => ({
	...prev,
	[EFetchReloadKey.allList]: {
		count: prev[EFetchReloadKey.allList].count + 1,
		updatedAt: helpers.getNowInMs()
	}
})